import { render, staticRenderFns } from "./PermissionItems.vue?vue&type=template&id=004c548d&scoped=true&"
import script from "./PermissionItems.vue?vue&type=script&lang=js&"
export * from "./PermissionItems.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItems.vue?vue&type=style&index=0&id=004c548d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c548d",
  null
  
)

export default component.exports